import { atom } from "recoil"

import type { Jobseeker } from "../interfaces/IJobseeker"

export const browsingHistoriesState = atom<Jobseeker[]>({
  key: "browsingHistories",
  default: [],
})
